module.exports = __webpack_public_path__ + "img/smartstore.dc862acd.png";